import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { App, type URLOpenListenerEvent } from '@capacitor/app';
import { hasNativePlugin } from './platform';

const PLUGIN_NAME = 'App';
const EXCLUDED_PREFIXES = ['/developer', '/error'];

@Injectable({ providedIn: 'root' })
export class DeepLinkService {
  readonly #router = inject(Router);
  #bound = false;

  async bind(): Promise<void> {
    if (this.#bound || !hasNativePlugin(PLUGIN_NAME)) return;
    this.#bound = true;

    await App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      const path = this.#extractPath(event.url);
      if (!path) return;
      if (
        EXCLUDED_PREFIXES.some((p) => path.startsWith(`${p}/`) || path === p)
      ) {
        return;
      }
      this.#router.navigateByUrl(path);
    });
  }

  #extractPath(rawUrl: string): string | null {
    try {
      const url = new URL(rawUrl);
      return `${url.pathname}${url.search}${url.hash}` || '/';
    } catch {
      return null;
    }
  }
}
